/**
 * Non-CAS (Higher Education) descriptor mapper.
 *
 * Maps a {@link Programme} to the {@link DescriptorData} for the canonical QQI
 * Higher Education programme descriptor. It consumes the shared descriptor core
 * ({@link buildDescriptorCore}) for the version-agnostic field mapping and shared
 * services; the non-CAS pathway adds no variant-specific overrides, so its output
 * is the canonical descriptor data unchanged.
 *
 * @module export/non-cas-descriptor-data
 */

import type { Programme } from "@/types";

import {
  buildDescriptorCore,
  type DescriptorBuildContext,
  type DescriptorData,
} from "./descriptor-core";

/**
 * Build the descriptor data for a non-CAS (Higher Education) programme.
 *
 * @param p - The full programme state
 * @returns DescriptorData ready for docx-templates createReport()
 */
export function buildNonCasDescriptorData(
  p: Programme,
  context: DescriptorBuildContext = {},
): DescriptorData {
  return buildDescriptorCore(p, context);
}
